import type { ApexOptions } from 'apexcharts'
import { localeNumberFormatter } from './chart-formatters'

export interface DonutChartItem {
  name: string
  value: number
  color: string
}

export interface DonutChartConfig {
  items: DonutChartItem[]
  height?: number
  donutSize?: string
}

export const buildDonutChartOptions = (config: DonutChartConfig): ApexOptions => {
  const { items, height = 300, donutSize = '65%' } = config

  const colors = items.map((item) => item.color)
  const labels = items.map((item) => item.name)
  const series = items.map((item) => item.value)

  return {
    chart: {
      type: 'donut',
      height
    },
    colors,
    labels,
    series,
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff']
    },
    plotOptions: {
      pie: {
        donut: {
          size: donutSize,
          labels: { show: false }
        }
      }
    },
    legend: { show: false },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value: number) => localeNumberFormatter(value)
      }
    }
  }
}
